import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import ProfileEmptyState from '../profile-empty-state';
import withCardBorderWidth from '../../../app/hoc/with-card-border-width';
import withFontClassName from '../../../app/hoc/with-font-class-name';

const EmptyState = ({ borderWidth, content, contentFontClassName, title, titleFontClassName, ...props }) => (
  <ProfileEmptyState
    borderWidth={borderWidth}
    className="blog-card-background-color blog-card-border-color blog-text-color"
    title={title}
    titleClassName={titleFontClassName}
    content={content}
    contentClassName={contentFontClassName}
    {...props}
  />
);

EmptyState.propTypes = {
  borderWidth: PropTypes.number,
  children: PropTypes.node,
  content: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleFontClassName: PropTypes.string,
};

// prettier-ignore
export default flowRight(
  withCardBorderWidth,
  withFontClassName,
)(EmptyState);
